import { useEffect, useState, useCallback } from "react";
import { apiFetch } from "../context/AuthContext";

const B    = "#2C1A0E";
const ROSE = "#C9847A";
const fmtR = (n) => n ? `₹${Number(n).toLocaleString("en-IN")}` : "—";

const CAT_COLOR = { Women: ROSE, Men: "#2C6E49", Kids: "#F4A261" };

export default function ProductsPage() {
  const [products, setProducts] = useState([]);
  const [loading,  setLoading]  = useState(true);
  const [catFilter,setCatFilter]= useState("All");
  const [typeFilter,setTypeFilter]=useState("All");

  const load = useCallback(async () => {
    setLoading(true);
    const r = await apiFetch("/api/products");
    if (r.ok) setProducts(await r.json());
    setLoading(false);
  }, []);

  useEffect(() => { load(); }, [load]);

  const filtered = products.filter(p =>
    (catFilter  === "All" || p.category === catFilter) &&
    (typeFilter === "All" || p.type === typeFilter)
  );

  return (
    <div style={{ padding: "28px 28px 80px", fontFamily: "Inter, sans-serif" }}>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: 20 }}>
        <div>
          <h1 style={{ fontFamily: "'Cormorant Garamond',Georgia,serif",
                       color: B, fontSize: 26, fontWeight: 700, margin: 0 }}>
            🧵 Products
          </h1>
          <p style={{ color: "#888", fontSize: 13, marginTop: 4 }}>
            Full catalogue · pricing, type, Shopify status
            <span style={{ marginLeft: 12, color: "#bbb" }}>
              (Inventory tab shows live stock levels per SKU)
            </span>
          </p>
        </div>
        <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
          {["All","Women","Men","Kids"].map(c => (
            <button key={c} onClick={() => setCatFilter(c)} style={{
              background: catFilter === c ? B : "#F0EBE3", color: catFilter === c ? "#FAF7F2" : B,
              border: "none", borderRadius: 6, padding: "5px 12px", fontSize: 12, fontWeight: 600, cursor: "pointer" }}>{c}</button>
          ))}
          <div style={{ width: 1, background: "#EDE0D4" }} />
          {["All","ready-to-ship","made-to-order"].map(t => (
            <button key={t} onClick={() => setTypeFilter(t)} style={{
              background: typeFilter === t ? "#555" : "#F0EBE3", color: typeFilter === t ? "#fff" : "#555",
              border: "none", borderRadius: 6, padding: "5px 12px", fontSize: 12, cursor: "pointer" }}>{t === "All" ? "All Types" : t}</button>
          ))}
        </div>
      </div>

      {/* KPIs */}
      <div style={{ display: "flex", gap: 14, marginBottom: 24 }}>
        {[
          { label: "Total SKUs",       value: products.length },
          { label: "Ready-to-ship",    value: products.filter(p => p.type === "ready-to-ship").length },
          { label: "Made-to-order",    value: products.filter(p => p.type === "made-to-order").length },
          { label: "Active on Shopify",value: products.filter(p => p.status === "active").length },
          { label: "Avg Price",        value: fmtR(products.reduce((s,p) => s+(p.price||0),0) / Math.max(products.length,1)) },
        ].map(({ label, value }) => (
          <div key={label} style={kpiCard}>
            <div style={{ fontSize: 11, color: "#888", marginBottom: 4 }}>{label}</div>
            <div style={{ fontSize: 18, fontWeight: 700, color: B }}>{value}</div>
          </div>
        ))}
      </div>

      {loading && <div style={{ color: "#aaa", fontSize: 13 }}>Loading…</div>}

      {!loading && (
        <div style={{ overflowX:"auto", borderRadius:12, border:"1px solid #EDE0D4" }}>
          <table style={{ width:"100%", borderCollapse:"collapse", fontSize:13, background:"#fff" }}>
          <thead>
            <tr style={{ background: "#F7F5F2" }}>
              {["SKU","Product","Category","Type","Price","Stock","Shopify Status","Image"].map(h => (
                <th key={h} style={th}>{h}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {filtered.map(p => (
              <tr key={p._id || p.sku_id} style={{ borderBottom: "1px solid #F0E8E0" }}>
                <td style={{ ...td, fontFamily: "monospace", fontWeight: 700, fontSize: 12, color: "#555" }}>
                  {p.sku_id || "—"}
                </td>
                <td style={{ ...td, fontWeight: 600, color: B }}>
                  {p.name || p.title || "—"}
                </td>
                <td style={td}>
                  <span style={{
                    background: (CAT_COLOR[p.category] || "#ccc") + "22",
                    color: CAT_COLOR[p.category] || "#666",
                    borderRadius: 4, padding: "2px 8px", fontSize: 11, fontWeight: 700 }}>{p.category || "—"}</span>
                </td>
                <td style={td}>
                  <span style={{
                    background: p.type === "ready-to-ship" ? "#DCFCE7" : "#DBEAFE",
                    color: p.type === "ready-to-ship" ? "#15803D" : "#1D4ED8",
                    borderRadius: 4, padding: "2px 8px", fontSize: 11 }}>{p.type || "—"}</span>
                </td>
                <td style={{ ...td, fontWeight: 600 }}>{fmtR(p.price)}</td>
                <td style={{ ...td, textAlign: "center" }}>
                  <span style={{
                    fontWeight: 700,
                    color: (p.stock_on_hand||0) === 0 ? "#DC2626"
                         : (p.stock_on_hand||0) < 3 ? "#854D0E" : "#15803D" }}>{p.stock_on_hand ?? "—"}</span>
                </td>
                <td style={td}>
                  {p.status && (
                    <span style={{
                      background: p.status === "active" ? "#DCFCE7" : "#F3F4F6",
                      color: p.status === "active" ? "#15803D" : "#6B7280",
                      borderRadius: 4, padding: "2px 8px", fontSize: 11 }}>{p.status}</span>
                  )}
                </td>
                <td style={td}>
                  {p.image_url
                    ? <img src={p.image_url} alt={p.name} style={{ width: 40, height: 40,
                              objectFit: "cover", borderRadius: 6 }} />
                    : <span style={{ fontSize: 20 }}>🧵</span>}
                </td>
              </tr>
            ))}
          </tbody>
          </table>
        </div>
      )}
    </div>
  );
}

const kpiCard = { background:"#fff", border:"1px solid #EDE0D4", borderRadius:12,
                  padding:"12px 16px", flex:1, minWidth:100 };
const th = { padding:"9px 14px", textAlign:"left", fontWeight:600, color:"#666",
             fontSize:11, textTransform:"uppercase", letterSpacing:0.5 };
const td = { padding:"10px 14px", verticalAlign:"middle" };
